import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';

const DECLINE_REASON = `${API_PREFIX}/decline-reason`;

@Injectable({
  providedIn: 'root',
})
export class DeclineReasonService {
  private readonly http = inject(HttpClient);

  checkNameUnique(name: string, excludedId?: number): Observable<boolean> {
    const params = new HttpParams()
      .set('name', name)
      .set('excludedId', String(excludedId ?? 0));

    return this.http
      .get<boolean | { data?: boolean }>(
        resolveUrl(`${DECLINE_REASON}/check-name-unique`),
        { params },
      )
      .pipe(
        map(response => {
          if (typeof response === 'boolean') {
            return response;
          }

          if (typeof response?.data === 'boolean') {
            return response.data;
          }

          return false;
        }),
      );
  }
}
